export default "__VITE_ASSET__CKvpgo8h__"